<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="状态" required prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="总次数" prop="count" class="frequency">
        <div style="display: flex;">
          <span slot="title" style="margin-right: 10px;">
            <el-tooltip class="item" effect="light" content="可完成该任务的总次数 0 不限制" placement="bottom">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input v-model.number="form.count" placeholder="请输入总次数" :clearable="true"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="场景次数" prop="sceneCount" class="frequency">
        <div style="display: flex;">
          <span slot="title" style="margin-right: 10px;">
            <el-tooltip class="item" effect="light" content="在单个场景中可完成的次数 如被邀请人重复下单可获得的奖励 0 不限制" placement="bottom">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input v-model.number="form.sceneCount" placeholder="请输入场景次数" :clearable="true"></el-input>
        </div>
      </el-form-item>
      <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
        <div
          style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
        >奖品区域</div>
        <el-collapse accordion>
          <el-collapse-item v-for="(item, index) in form.gifts" :key="index">
            <span
              slot="title"
              style="font-size:15px;font-weight:600; margin:20px;"
            >奖品名称： {{item.name}}</span>
            <el-form-item
              label="奖品名称"
              required
              :prop="'gifts.' + index + '.name'"
              :rules="[
      { required: true, message: '奖品名称不能为空', trigger: 'blur' },
    ]"
            >
              <el-input v-model="item.name" placeholder="请输入奖品名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="数量"
              required
              :prop="'gifts.' + index + '.count'"
              :rules="[
      { required: true, message: '奖品数量不能为空', trigger: 'blur' },
      { type: 'number', message: '奖品数量必须为数字值' },
          { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}
    ]"
            >
              <el-input v-model.number="item.count" placeholder="请输入奖品数量" :clearable="true"></el-input>
            </el-form-item>
            <el-collapse accordion>
              <el-collapse-item>
                <span
                  style="font-size:14px;font-weight:600; margin:20px;padding-left:110px"
                  slot="title"
                >
                  奖品信息
                  <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>
                </span>
                <el-form-item label="类型">
                  <el-radio-group
                    v-model="item.type"
                    @change="function(e){
              skuType(e,index)
            }"
                  >
                    <el-radio :label="0">无奖品</el-radio>
                    <el-radio :label="1">实体物品</el-radio>
                    <el-radio :label="2">克拉数(如果选中克拉数,则你输入的数会被除于10000)</el-radio>
                    <el-radio :label="3">优惠券</el-radio>
                    <el-radio :label="4">经验值</el-radio>
                    <el-radio :label="5">抽奖机会</el-radio>
                    <el-radio :label="6">勋章</el-radio>
                    <el-radio :label="7">属性值</el-radio>
                    <el-radio :label="8">机会卷</el-radio>
                    <el-radio :label="9">打卡任务</el-radio>
                    <el-radio :label="10">委托卡片</el-radio>
                    <el-radio style="margin-top: 10px;" :label="11">大赛</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="虚拟物品值" required>
                  <el-input
                    v-model="item.value"
                    placeholder="请输入虚拟物品值(id)"
                    :clearable="true"
                    :disabled="item.type == 0 || 1||2||4 ? true :false"
                    v-if="item.type == 0|| item.type == 1 ||item.type == 2 ||item.type == 4"
                  ></el-input>
                  <el-select
                    v-if="item.type == 3"
                    clearable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择优惠券"
                    style="margin-right: 20px;"
                  >
                    <el-option
                      v-for="item in couponsList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="item.type == 5"
                    clearable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择抽奖"
                    style="margin-right: 20px;"
                  >
                    <el-option
                      v-for="item in rafflesList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="item.type == 6"
                    clearable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择勋章"
                    style="margin-right: 20px;"
                  >
                    <el-option
                      v-for="item in medalsList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select v-model="item.value" placeholder="请选择属性" v-if="item.type == 7">
                    <el-option-group
                      v-for="group in options"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                    v-if="item.type == 8"
                    clearable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择委托"
                    style="margin-right: 20px;"
                  >
                    <el-option
                      v-for="getCR in getCRsList"
                      :key="getCR.id"
                      :label="getCR.name"
                      :value="getCR.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="item.type == 9"
                    clearable
                    filterable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择打卡任务"
                    style="margin-right: 20px;"
                  >
                    <el-option
                      v-for="getCR in getsThemeList"
                      :key="getCR.id"
                      :label="getCR.title"
                      :value="getCR.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="item.type == 10"
                    clearable
                    class="filter-item"
                    v-model="item.value2"
                    placeholder="请选择委托"
                    style="margin-right: 20px;"
                    @change="function(e){
              skusType(e,index)
            }"
                  >
                    <el-option
                      v-for="getCR in getCRsList"
                      :key="getCR.id"
                      :label="getCR.name"
                      :value="getCR.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="item.type == 10"
                    clearable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择委托卡片"
                    style="margin-right: 20px;"
                    :disabled="item.value2 == ''"
                  >
                    <el-option
                      v-for="getCR in item.getCardList"
                      :key="getCR.id"
                      :label="getCR.companyName + ' -酬劳:'+getCR.reward"
                      :value="getCR.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="item.type == 11"
                    clearable
                    class="filter-item"
                    v-model="item.value"
                    placeholder="请选择大赛"
                    style="margin-right: 20px;"
                  >
                    <el-option
                      v-for="item in megagameList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
            <div style="display: flex;justify-content: center;margin-top: 14px;">
              <el-button type="danger" size="mini" @click="removeList(index)">-删除奖品</el-button>
            </div>
          </el-collapse-item>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button>
          </div>
        </el-collapse>
      </div>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" :clearable="true"></el-input>
      </el-form-item>
      <div class="tc" v-if="!editorialJudgment">
        <el-button type="primary" size="default" @click="seve('form')">新 增</el-button>
        <el-button size="default" @click="closeFn">取 消</el-button>
      </div>
      <div class="tc" v-if="editorialJudgment">
        <el-button @click="closeFn">取 消</el-button>
        <el-button type="primary" @click="getModify('form')">编 辑</el-button>
      </div>
    </el-form>
  </d2-container>
</template>
<script>
import { attList } from '@/api/demo/attributes/index'
import { getArrList } from '@/api/demo/discount/index'
import { getLuckList } from '@/api/demo/luckDraw/index'
import { getMedalList } from '@/api/demo/medal/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { megagameList } from '@/api/demo/competition/index'
import {
  getAddTasks,
  getModifyTasks,
  getTasksInfo
} from '@/api/demo/systemTasks/index'

export default {
  name: 'createTask',
  data () {
    return {
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [], // 打卡任务
      megagameList: [], // 大赛
      editorialJudgment: false,
      tasId: '',
      form: {
        name: '', // 名称
        status: 1, // 状态 1 开启 0 关闭
        count: '',
        sceneCount: '',
        gifts: [
          {
            count: '', // 奖品数量
            name: '', // 奖品名称
            type: 0, // 奖品类型
            id: null, // 奖品id
            value: '' // 奖品值
          }
        ]
      },
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] }
      ],
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        count: [
          { required: true, message: '总次数不能为空' },
          { type: 'number', message: '总次数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        sceneCount: [
          { required: true, message: '场景次数不能为空' },
          { type: 'number', message: '场景次数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.tasId = that.$route.query.id
    if (that.tasId != null) {
      that.editorialJudgment = true
      that.getTasksInfo(that.tasId)
    }
    that.couponList()
    that.raffleList()
    that.medalList()
    that.getAttributes()
    that.getCRList()
    that.getThemesList()
    that.getMegagameList()
  },
  methods: {
    // 详情
    getTasksInfo (id) {
      let that = this
      getTasksInfo(id).then(res => {
        console.log('res.data', res)
        that.form = res
      })
    },
    // 大赛
    getMegagameList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 40,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.megagameList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 40
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 卡片列表
    getCardsList (e, index) {
      let that = this
      getCard(e).then(res => {
        that.form.gifts[index].getCardList = res
      })
    },
    skusType (e, index) {
      console.log('ee', e, index)
      let that = this
      if (e == '') {
      } else {
        that.getCardsList(e, index)
      }
    },
    // 类型
    skuType (e, index) {
      // console.log("index", e,index);
      let that = this
      for (let index2 = 0; index2 < that.form.gifts.length; index2++) {
        if (that.form.gifts[index2] == index) {
          that.form.gifts[index2].type = e
        }
      }
      // console.log("index", this.form.gifts);
    },
    addList () {
      this.form.gifts.push({
        count: '', // 奖品数量
        name: '', // 奖品名称
        type: 0, // 奖品类型
        value: '', // 奖品值
        id: null // 奖品id
      })
    },
    removeList (index) {
      this.form.gifts.splice(index, 1)
      this.form.gifts.forEach((item, index) => {
        item.index = index
      })
    },
    // 取消
    closeFn () {
      let that = this
      that.$router.push({
        path: '/demo/systemTasks'
      })
    },
    // 新增
    seve (form) {
      let that = this
      that.$refs[form].validate(valid => {
        if (valid) {
          getAddTasks(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/systemTasks'
            })
          })
        }
      })
    },
    // 编辑
    getModify (form) {
      let that = this
      that.$refs[form].validate(valid => {
        if (valid) {
          getModifyTasks(that.tasId, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/systemTasks'
            })
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
<style scoped>
.tc {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
